<template>
    <div class="modal-container-cont">
        <div class="overlay"></div>
        <div class="modal-container">
            <div class="message-container">
                <p v-html="message"></p>
            </div>
            <div class="buttons-container">
                <DefaultButton :text="getString('Cancelar')" :outlined="true" @defaultBtnClick="closeModal()"></DefaultButton>
            </div>
        </div>
    </div>
</template>

<script>
import LocaleController from '@/assets/controllers/LocaleController'
import DefaultButton from '@/components/DefaultButton'
import Util from '@/assets/libs/util'
import PaymentController from '@/assets/controllers/PaymentController'
import SaleController from '@/assets/controllers/SaleController'
export default {
    name: 'PendingConfirmationModal',
    components: {
        DefaultButton
    },
    props: ['pendingConfirmationData'],
    data () {
        return {
            message: this.getString('aguarde') + '...',
            hasPendingConfirmation: false
        }
    },
    mounted () {
        this.checkPendingConfirmation()
    },
    methods: {
        getString: function (key) {
            return LocaleController.getString(key)
        },
        isAndroidMode: function () {
            return Util.isAndroidMode()
        },
        closeModal: function () {
            this.$emit('closePendingConfirmationModal')
        },
        checkPendingConfirmation: async function () {
            try {
                let resultFinishTransactionTEF = false
                let transactionData = PaymentController.getFlagStatusTef()
                let confirm = transactionData.finishTef || 0
                let saleCode = transactionData.saleCode || null
                if (!transactionData || !transactionData.date || !transactionData.value) {
                    // this.message = this.getString('transacao_pendente_nao_encontrada')
                    // await Util.sleep(2000)
                    PaymentController.setFlagStatusTef(null)
                    this.closeModal()
                    return
                }
                this.message = this.getString('verificando_transacoes_pendentes')
                await Util.sleep(2000)
                this.hasPendingConfirmation = await PaymentController.checkPendingConfirmation(transactionData)

                if (this.hasPendingConfirmation) {
                    this.message = this.getString('finalizando_transacao_pendente')
                    resultFinishTransactionTEF = await PaymentController.finishIncompleteTransaction(transactionData)
                    if (!resultFinishTransactionTEF) {
                        Util.showInfoModal(this.getString('nao_foi_possivel_confirmar_transacao'))
                        PaymentController.setFlagStatusTef(null)
                        this.closeModal()
                        return
                    }
                }

                if (!saleCode) {
                    Util.showInfoModal(this.getString('nao_ha_venda_a_ser_finalizada'))
                    PaymentController.setFlagStatusTef(null)
                    this.closeModal()
                    return
                }

                if (Util.isTapMode() && Util.isAndroidMode() && saleCode && confirm === 0) {
                    this.message = this.getString('cancelando_comanda_pendente')
                    let cancelPaymentResponse = await SaleController.cancelPaymentsTAP(saleCode)
                    let errorCancelingAlreadyClosedOrder = cancelPaymentResponse && cancelPaymentResponse.error &&
                    cancelPaymentResponse.data && cancelPaymentResponse.data.errorCode === 1

                    if (errorCancelingAlreadyClosedOrder) {
                        await SaleController.cancelSale(null, saleCode)
                    }
                    Util.showInfoModal(this.getString('ultima_transacao_nao_finalizada_cancelada'))
                }

                if (Util.isTapMode() && Util.isAndroidMode() && saleCode && confirm === 1) {
                    this.message = this.getString('concluindo_comanda_pendente')
                    await SaleController.clearComanda(saleCode)
                    Util.showInfoModal(this.getString('ultima_transacao_nao_finalizada_concluida'))
                }

                if (!Util.isTapMode() && Util.isAndroidMode() && saleCode && confirm === 0) {
                    this.message = this.getString('cancelando_venda_pendente')
                    let cancelResponse = await SaleController.cancelOrder(saleCode)
                    if (cancelResponse && !cancelResponse.error) {
                        Util.showInfoModal(this.getString('ultima_transacao_nao_finalizada_cancelada'))
                    }
                }

                if (!Util.isTapMode() && Util.isAndroidMode() && saleCode && confirm === 1) {
                    this.message = this.getString('concluindo_venda_pendente')
                    Util.showInfoModal(this.getString('ultima_transacao_nao_finalizada_concluida'))
                }
                PaymentController.setFlagStatusTef(null)
            } catch (error) {
                console.error(error)
                Util.showInfoModal(this.getString('erro_ao_verificar_transacoes_pendentes'))
            }
            this.closeModal()
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>
@import (reference) url("../assets/common.less");

.modal-container-cont {
    .full;
    pointer-events: none;
    display: block;
    bottom: 0;
    z-index: 1000;
    .overlay {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        background: rgba(0, 0, 0, 0.8);
        z-index: 998;
        pointer-events: auto;
    }
}

.modal-container {
    position: absolute;
    pointer-events: auto;
    left: 0;
    right: 0;
    top: 50%;
    margin: auto 75px;
    background: @white;
    border-radius: 25px;
    box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.1);
    transform: translate(0%, -50%);
    height: max-content;
    z-index: 999;
    min-height: 200px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .message-container {
        font-size: 25px;
        font-weight: bold;
        color: @black;
    }
    .buttons-container {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        margin: 20px 0;
    }
}

@media (max-width: 698px) {

    // Gertec SK210
    .modal-container {
        margin: auto 30px;
        min-height: 150px;
        .message-container {
            font-size: 20px;
        }
        .buttons-container {
            margin: 5px 0;
        }
    }
}

@media (min-width: 699px) and (max-width: 1025px) {

    //@tablet
    .modal-container {
        margin: auto 50px;
        .buttons-container {
            flex-direction: column;
        }
    }

}
</style>



// WEBPACK FOOTER //
// src/components/PendingConfirmationModal.vue